import LaunchpadLayout from "../../launchpad/LaunchpadLayout";
import LaunchpadHeader from "../../launchpad/LaunchpadHeader";
import FeaturedServiceCard from "../../service/FeaturedServiceCard";
import WorshipSongsSection from "../../library/WorshipSongsSection";
import PlaylistsSection from "../../library/PlaylistsSection";
import EventsHomeSection from "../../event/EventsHomeSection";
import LaunchpadLinks from "component/launchpad/LaunchpadLinks";
import LaunchpadFooter from "component/launchpad/LaunchpadFooter";

import { SAMPLE_LAUNCHPAD } from "../../../sample/launchpad";

export default function Test() {
  const { metadata, latestService, playlists, events } = SAMPLE_LAUNCHPAD;
  const songs = latestService?.attributes.songs ?? [];
  const links = metadata.attributes.links ?? [];

  return <LaunchpadLayout>
    <LaunchpadHeader metadata={metadata} />

    {links.length > 0 && <LaunchpadLinks links={links} />}

    {latestService && (
      <FeaturedServiceCard service={latestService} />
    )}

    {songs.length > 0 && <WorshipSongsSection songs={songs} />}

    {events.length > 0 && <EventsHomeSection events={events} />}

    {playlists.length > 0 && <PlaylistsSection playlists={playlists} />}

    <LaunchpadFooter />
  </LaunchpadLayout>
}
